import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Enterprise, EntityType } from '../entity.types';
import { EntityInfos } from '../expertises/infos/EntityInfos';
import { EnterpriseList } from '../entity-lists/EnterpriseList';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../components/EntityBlockComponents';
import { SeeMore } from '../../components/see-more/SeeMore';

type Props = {
  enterprises: Array<Enterprise>;
  entityName: string;
  entityType: EntityType;
  entityId: string;
  decisionCount: number;
  source: string;
  pluralityState: number;
  wording: string;
  handleSeeMoreEnterprisesClick:
    | ((event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void)
    | null;
  handleClickDecision: Function;
};

export const EntityDefendedEnterprises: FC<Props> = ({
  entityName,
  pluralityState,
  handleSeeMoreEnterprisesClick,
  enterprises,
  source,
  entityType,
  entityId,
  decisionCount,
  handleClickDecision,
  wording,
}) => {
  if (!pluralityState) return null;

  return (
    <EntityBlock>
      <EntityBlockTitle>
        <FormattedMessage
          id="defended-enterprises/DefendedEnterprises.tsx/1"
          values={{ count: pluralityState }}
        />
      </EntityBlockTitle>
      <EntityInfos
        decisionCount={decisionCount}
        entityType={entityType}
        lawyerId={entityId}
        entityName={entityName}
      />
      <EnterpriseList
        enterprises={enterprises}
        source={source}
        wording={wording}
        handleClickDecision={handleClickDecision}
      />
      {handleSeeMoreEnterprisesClick !== null && (
        <SeeMore onClick={handleSeeMoreEnterprisesClick}>
          <FormattedMessage id="defended-enterprises/DefendedEnterprises.tsx/3" />
        </SeeMore>
      )}
    </EntityBlock>
  );
};
